module.exports = __webpack_public_path__ + "static/media/mail-profile.caebe6c3.svg";